export const iconFontAwesomeMedicalHealthHeartCircleCheck = (
	<i className="fa-solid fa-heart-circle-check"></i>
);
